const BusinessInfo = () => {
	return <div>BusinessInfo</div>;
};

export default BusinessInfo;
